// extracted by mini-css-extract-plugin
module.exports = {"input":"salaryByLocation_input__ZP24_"};